import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/tokens.css'
import './index.css'
import './styles/components.css'
import App from './App.tsx'
import { ThemeProvider } from './contexts/ThemeProvider'

const buildInfo = {
  sha: import.meta.env.VITE_GIT_SHA || 'unknown',
  date: import.meta.env.VITE_BUILD_DATE || 'unknown',
}

if (typeof window !== 'undefined') {
  ;(window as Window & { __BASICOLOG_BUILD__?: typeof buildInfo }).__BASICOLOG_BUILD__ = buildInfo
}

console.info('[Basicolog Build]', buildInfo)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>,
)
